import {
  Box,
  Tooltip as MuiTooltip,
  type TooltipProps as MuiTooltipProps,
  type SxProps,
  styled,
  tooltipClasses,
} from '@mui/material';
import { colors } from '@ovComponents/0-tokens/ref/palette/palette';
import type { ReactNode } from 'react';

type TooltipFunctionalProps = {
  placement?: MuiTooltipProps['placement'];
  title: string | ReactNode;
  children: React.ReactElement | React.ReactElement[] | string;
  open?: boolean;
};

type TooltipVisualProps = {
  resizing?: 'wrap' | 'fixedSmall' | 'fixedMedium' | 'fixedLarge';
  wrapperSx?: SxProps;
};

export const Tooltip = ({
  wrapperSx,
  ...props
}: TooltipFunctionalProps & TooltipVisualProps) => (
  <ArrowTooltip {...props}>
    <Box component='div' sx={wrapperSx}>
      {props.children}
    </Box>
  </ArrowTooltip>
);

const ArrowTooltip = styled(
  ({ className, ...props }: MuiTooltipProps & TooltipVisualProps) => (
    <MuiTooltip
      arrow
      {...props}
      classes={{ popper: className }}
      open={props.open}
    />
  ),
)((props) => {
  let width;
  if (props.resizing === 'fixedSmall') width = 150;
  if (props.resizing === 'fixedMedium') width = 300;
  if (props.resizing === 'fixedLarge') width = 500;

  return {
    [`& .${tooltipClasses.arrow}`]: {
      color: colors.neutral800,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      padding: '12px',
      backgroundColor: colors.neutral800,
      fontSize: 12,
      textAlign: 'center',
      width,
      maxWidth: width,
    },
  };
});
